





































import { defineComponent, ref } from "@vue/composition-api";
import { v4 as uuid } from "uuid";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { NOTIFICATION_STATUS } from "@monorepo/utils/src/eventBus/types/notification";
import { showNotification } from "@monorepo/utils/src/eventBus/utils/showNotification";
import useCheckChangesModal from "@monorepo/utils/src/composables/useCheckChangesModal";
import InfoBlock from "@monorepo/app/src/views/Profile/components/info/InfoBlock.vue";
import { infoElements } from "@monorepo/utils/src/variables/projectsData/profileView/infoElements";
import { convertUserFromApi } from "@monorepo/app/src/views/Profile/components/info/utils/convertUserFromApi";
import { viewUniqKey } from "@monorepo/utils/src/variables/projectsData/profileView/viewTitle";
import { convertSaveCardObject } from "@monorepo/app/src/views/Profile/components/info/utils/convertSaveCardObject";
import AvatarSettings from "@monorepo/app/src/views/Profile/components/info/AvatarSettings.vue";

export default defineComponent({
  name: "InfoView",
  components: {
    InfoBlock,
    AvatarSettings,
  },
  data(): {
    key: string;
    viewUniqKey: string;
    isSaveLoading: boolean;
    isLoading: boolean;
    infoElements: typeof infoElements;
    userRoles: string[];
    userData: any;
  } {
    return {
      isSaveLoading: false,
      key: uuid(),
      viewUniqKey,
      isLoading: false,
      infoElements,
      userRoles: [],
      userData: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["user", "isShowAnimation"]),
  },
  methods: {
    ...mapActions("auth", ["saveUserInfo", "getUserData", "getUserRoles"]),
    ...mapMutations("auth", ["setUserDetails"]),
    getResultSaveData(data: any) {
      return convertSaveCardObject(data);
    },
    async onSave(data: Record<string, string | boolean>) {
      const isNeedSave = (this as unknown as { checkChangesBeforeSave: () => boolean }).checkChangesBeforeSave();
      if (!isNeedSave) {
        return;
      }
      const resultData = this.getResultSaveData(data);

      this.isSaveLoading = true;
      const isSaved = await this.saveUserInfo(resultData).finally(() => {
        this.isSaveLoading = false;
      });
      if (isSaved) {
        this.changedFormValues = resultData;
        this.setUserDetails({
          phone: resultData.phone,
          position: resultData.position,
        });

        showNotification("Данные успешно сохранены.", NOTIFICATION_STATUS.SUCCESS);
      } else {
        showNotification("Ошибка сохранения данных.");
      }
    },
    resetValues() {
      this.formValues = convertUserFromApi(this.user, this.userData);
    },
    changeContracts(contracts: Record<string, string>[], values: Record<string, string>) {
      (
        this as unknown as {
          $formulate: {
            setValues: (key: string, object: Record<string, string>) => void;
          };
        }
      ).$formulate.setValues("user-info", Object.assign(values, { contracts }));
    },
  },
  async mounted() {
    const [userData, userRoles] = await Promise.all([this.getUserData(this.user?.details?.userId), this.getUserRoles()]).catch(() => [null, []]);

    this.userData = userData;
    this.formValues = convertUserFromApi(this.user, this.userData);
    this.changedFormValues = this.getResultSaveData(this.formValues);
    this.userRoles = userRoles;
  },
  setup(props, context) {
    const formValues = ref({});
    const changedFormValues = ref({});
    const { checkChangesBeforeClose, checkChangesBeforeSave } = useCheckChangesModal(context, formValues, changedFormValues, convertSaveCardObject);

    return {
      formValues,
      changedFormValues,
      checkChangesBeforeClose,
      checkChangesBeforeSave,
    };
  },
});
